import { Box, Flex, SimpleGrid, Stack } from "@chakra-ui/react";
import React, { FC } from "react";
import { Else, If, Then } from "react-if";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { IDirectionBanner } from "../models/banner";
import { BrandHeadingHero, MediaCoverHero } from "../style";
import Icon from "@modules/Icon";
import MediaModal from "./MediaModal";
import useMediaModal from "@modules/Resource/hooks/useMediaModal";
import FluidImage from "./FluidImage";
import ActionButton from "./ActionButton";
interface IProps {
  data: IDirectionBanner;
  coverBorder?: "xs" | "md" | "lg" | "xl" | "2xl" | "none";
}

const MediaCustomCover: FC<IProps> = ({ data, coverBorder = "none" }) => {
  if (!data) {
    return null;
  }

  const coverImage = data.cover?.data?.attributes?.url;
  const isVideo = data.media_type === "video";
  const hasMedia = coverImage || data.media_url;

  const { isOpen, handleOpenModal, handleCloseModal, mediaType, mediaUrl } =
    useMediaModal();

  return (
    <MediaCoverHero>
      <SimpleGrid
        columns={[1, 1, 2]}
        spacing={{ base: 5, lg: 40 }}
        alignItems={"center"}
      >
        <Box pl={{ base: 4, md: 0 }} pr={{ base: 4, md: 0 }}>
          <BrandHeadingHero>
            <ReactMarkdown children={data.content} />

            <ActionButton actions={data.action} />
          </BrandHeadingHero>
        </Box>

        <If condition={hasMedia}>
          <Then>
            <Flex
              direction={["column", "column", "row"]}
              alignItems="center"
              justifyContent={["center", "center", "normal"]}
              pr={{ base: 0 }}
            >
              <If condition={isVideo && data?.media_url}>
                <Then>
                  <Stack
                    position="relative"
                    onClick={() => handleOpenModal("video", data?.media_url)}
                    style={{ cursor: "pointer" }}
                    className="custom-video-cover"
                  >
                    <FluidImage
                      imageItem={data.cover}
                      borderRadius={coverBorder}
                    >
                      <Icon
                        className="custom-video-play-icon"
                        name="playVideo"
                      />
                    </FluidImage>
                  </Stack>
                </Then>
                <Else>
                  <FluidImage
                    imageItem={data.cover}
                    borderRadius={coverBorder}
                  />
                </Else>
              </If>
            </Flex>
          </Then>
        </If>
      </SimpleGrid>

      <If condition={data.media_url}>
        <Then>
          <MediaModal
            type={"video"}
            url={data.media_url}
            isOpen={isOpen}
            handleCloseModal={handleCloseModal}
          />
        </Then>
      </If>
    </MediaCoverHero>
  );
};

export default MediaCustomCover;
